module.exports = __webpack_public_path__ + "img/add.c186c764.svg";